import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ContactCaseLinkProps {
  dealId: number | null | undefined;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  fontSize?: number;
  fontWeight?: number;
  isRecycled?: boolean;
  reactivationCount?: number;
}

const ContactCaseLink: FC<ContactCaseLinkProps> = ({
  dealId,
  firstName,
  lastName,
  // Design-Rollout 25.10.2026: Standard 14 (Rolle wert/wertBetont) statt 13.
  fontSize = 14,
  fontWeight = 500,
  isRecycled = false,
  reactivationCount = 0,
}) => {
  const navigate = useNavigate();
  const name = `${firstName || ''} ${lastName || ''}`.trim() || '—';

  const rcBadge = isRecycled ? (
    <Box
      component="span"
      sx={{
        // Flach wie RcMeetingBadge (Rolle label, 8px Ecken).
        typography: 'label',
        px: 2,
        py: 0.5,
        borderRadius: '8px',
        bgcolor: 'warning.flaeche',
        color: 'warning.text',
        ml: 2,
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
    >
      {reactivationCount ? `RC (Versuch ${reactivationCount})` : 'RC'}
    </Box>
  ) : null;

  if (!dealId) {
    return (
      <Typography sx={{ fontSize, fontWeight, color: 'text.strong', lineHeight: 1.4 }}>
        {name}{rcBadge}
      </Typography>
    );
  }

  // Echter Anker (FB 152): Strg-/Cmd-/Mittelklick oeffnen den Case nativ im
  // neuen Tab. Nur der unmodifizierte Linksklick bleibt SPA-Navigation.
  return (
    <Typography
      component="a"
      href={`/home/cases/${dealId}`}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        e.stopPropagation();
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        navigate(`/home/cases/${dealId}`);
      }}
      onAuxClick={(e: React.MouseEvent<HTMLAnchorElement>) => e.stopPropagation()}
      sx={{
        fontSize,
        fontWeight,
        color: 'primary.main',
        lineHeight: 1.4,
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      {name}{rcBadge}
    </Typography>
  );
};

export default ContactCaseLink;
